//@ts-check
import { Content, Divider, Flex, Heading, InlineAlert, Text, View } from '@adobe/react-spectrum';
import React, { useContext } from 'react';

import { PartnerBadge, TraderInformation } from '@exchange-frontends/components';

import { DetailHeading } from '../../../../../components/DetailHeading';
import WithSkeleton from '../../../../../components/WithSkeleton';
import { useStore } from '../../../store';
import { AppDetailsContext } from '../AppDetails';
import ContactPublisherButton from './ContactPublisherButton';
import PublisherLink from './PublisherLink';
import SlnSidebarPublisher from './SlnSidebarPublisher';

const SidebarPublisher = () => {
  const { cloud, isPreview, isEUUser, fallsUnderDigitalServicesAct } = useContext(AppDetailsContext);
  const detailScreenLoading = useStore((state) => state.detailScreenLoading);
  const appType = useStore((state) => state.detailScreen?.appType);
  /** @type {import('@action-types/ecApp').AppDetails} */
  const detailScreen = useStore((state) => state.detailScreen || {});

  const { publisher } = detailScreen;
  const { id, name, level } = publisher || {};

  const isSolution = appType === 'SLN';
  const isIntegration = appType === 'integrations';
  const isNotAdobePublisher = id && id !== '0011400001vdyqkAAA';
  const isEc = cloud?.toLowerCase() === 'ec';
  const hasContactDetails = !!publisher?.contactDetails;
  const shouldShowTraderInfo = isEUUser && (fallsUnderDigitalServicesAct || hasContactDetails);

  return (
    <>
      <DetailHeading level={4}>{isSolution ? 'Partner' : 'Publisher'}</DetailHeading>
      <View
        backgroundColor="static-white"
        borderRadius="regular"
        padding="size-200"
        borderWidth="thin"
        borderColor="gray-200"
        marginBottom="size-400"
      >
        <Flex direction="column" gap="size-200">
          <WithSkeleton>
            {!detailScreenLoading && (
              <>
                {isIntegration ? (
                  name
                ) : (
                  <PublisherLink>
                    <Flex gap="size-200" justifyContent="space-between">
                      <Text data-testid="publisherName-display" data-launchid="Publisher">
                        {name}
                      </Text>
                      <PartnerBadge level={level} appType={appType} />
                    </Flex>
                  </PublisherLink>
                )}
              </>
            )}
          </WithSkeleton>
          {!isSolution && isEc && isNotAdobePublisher && (
            <Flex width="100%" justifyContent="center">
              <ContactPublisherButton isPreview={isPreview} />
            </Flex>
          )}
          {isSolution && <SlnSidebarPublisher />}
          {shouldShowTraderInfo && (
            <>
              <Divider size="S" marginX="-16px" />
              <TraderInformation contactDetails={publisher?.contactDetails} />
            </>
          )}
        </Flex>
      </View>
      {shouldShowTraderInfo && isPreview && (
        <InlineAlert width="100%" variant="info" marginTop="-16px" marginBottom="size-400">
          <Heading>Trader information visibility</Heading>
          <Content>
            The trader information section will be visible only to users in the <abbr title="European Union">EU</abbr>.
          </Content>
        </InlineAlert>
      )}
    </>
  );
};

export default SidebarPublisher;
